var _a, _b;
import { __assign, __spreadArray } from "tslib";
import { handleActions } from 'redux-actions';
import { initializeDuperbrowse, openDuperbrowse, exitDuperbrowse, setCurrentItem, setCurrentStreamAndItem, shutdownDuperbrowse, exitDuperbrowseResorationTimeout, loadDuperbrowseItem, } from './actionCreators';
import { reduxKey, initialState } from './constants';
import history from '../../redux/routing/history';
var actionHandler = handleActions((_a = {},
    _a[initializeDuperbrowse.toString()] = function (state, _a) {
        var _b = _a.payload, initialStream = _b.initialStream, enableHistoryManagement = _b.enableHistoryManagement;
        return (__assign(__assign({}, state), { rootStream: initialStream, lastViewedItem: undefined, isHistoryManagementEnabled: enableHistoryManagement !== null && enableHistoryManagement !== void 0 ? enableHistoryManagement : true }));
    },
    _a[openDuperbrowse.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { streamStack: __spreadArray([payload], state.streamStack), isSessionActive: true, rootLocation: state.isSessionActive
                ? state.rootLocation
                : __assign({}, history.location), lastViewedItem: undefined }));
    },
    _a[exitDuperbrowse.toString()] = function (state) {
        var _a = state.streamStack, topStream = _a[0], restStack = _a.slice(1);
        return __assign(__assign({}, state), { streamStack: restStack, isSessionActive: restStack.length > 0, lastViewedItem: topStream
                ? {
                    streamId: topStream.streamId,
                    itemId: topStream.currentOpenItem,
                }
                : undefined });
    },
    _a[exitDuperbrowseResorationTimeout.toString()] = function (state) {
        return __assign(__assign({}, state), { lastViewedItem: undefined });
    },
    _a[shutdownDuperbrowse.toString()] = function (state) { return (__assign(__assign({}, state), { streamStack: [], isSessionActive: false, lastViewedItem: state.streamStack && state.streamStack.length
            ? {
                streamId: state.streamStack[state.streamStack.length - 1].streamId,
                itemId: state.streamStack[state.streamStack.length - 1].currentOpenItem,
            }
            : undefined })); },
    _a[setCurrentItem.toString()] = function (state, _a) {
        var itemId = _a.payload.itemId;
        var _b = state.streamStack, topStream = _b[0], restStack = _b.slice(1), rootStream = state.rootStream;
        if (!topStream && !!rootStream) {
            return __assign(__assign({}, state), { rootStream: __assign(__assign({}, rootStream), { currentOpenItem: itemId }) });
        }
        var stream = state.streamStack[0];
        if (!stream) {
            return state;
        }
        var updatedStream = __assign(__assign({}, stream), { currentOpenItem: itemId });
        return __assign(__assign({}, state), { streamStack: __spreadArray([updatedStream], restStack) });
    },
    _a[setCurrentStreamAndItem.toString()] = function (state, _a) {
        var _b = _a.payload, streamId = _b.streamId, itemId = _b.itemId;
        var streamIndex = state.streamStack.findIndex(function (st) { return st.streamId === streamId; });
        var stream = streamIndex < 0 ? undefined : state.streamStack[streamIndex];
        if (stream) {
            // pop all the other potential streams, and set to specified item
            var newStack = __spreadArray([
                __assign(__assign({}, stream), { currentOpenItem: itemId })
            ], state.streamStack.slice(streamIndex + 1));
            return __assign(__assign({}, state), { streamStack: newStack });
        }
        if (state.rootStream && state.rootStream.streamId === streamId) {
            return __assign(__assign({}, state), { streamStack: [], isSessionActive: false, rootStream: __assign(__assign({}, state.rootStream), { currentOpenItem: itemId }) });
        }
        return state;
    },
    _a[loadDuperbrowseItem.toString()] = function (state, _a) {
        var _b;
        var itemSchema = _a.payload.itemSchema;
        if (itemSchema !== 'deviation') {
            return state;
        }
        return __assign(__assign({}, state), { loadCount: ((_b = state.loadCount) !== null && _b !== void 0 ? _b : 0) + 1 });
    },
    _a), initialState);
export default (_b = {},
    _b[reduxKey] = actionHandler,
    _b);
//# sourceMappingURL=reducer.js.map